import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import { translateError } from '@/shared/api/errors'

interface LoadErrorProps {
  /**
   * NIMA yuklanmagani — `plans.loadFailed`, `usage.loadFailed` va h.k.
   * ⚠️ Kalit, tayyor matn EMAS: xom satr bu yerga tushsa u tarjima
   * qatlamidan o'tmaydi (§23.6 dagi `client.ts` tuzog'ining aynan o'zi).
   */
  titleKey: string
  error: unknown
}

/**
 * Ma'lumot yuklanmaganda ko'rsatiladigan xato.
 *
 * <h2>⚠️ NEGA ALOHIDA KOMPONENT — «hammasi bir xil ko'rinardi»</h2>
 *
 * Ilgari har sahifada shunday yozilardi:
 *
 * <pre>{@code <Alert type="error" showIcon message={translateError(err, t)} />}</pre>
 *
 * `translateError` esa NIMA yuklanmaganini BILMAYDI — u faqat HTTP
 * holatini biladi. Ya'ni tarmoq uzilganda abonent BEShTA sahifada ham
 * aynan bitta jumlani ko'rardi: «Serverga ulanib bo'lmadi…».
 *
 * ⚠️ Bosh sahifada bu ayniqsa yomon edi: u IKKI mustaqil so'rov yuboradi
 * (balans va trafik), ya'ni bitta ekranda IKKITA bir xil qizil qutini
 * yonma-yon ko'rsatishi mumkin edi. Qaysi biri nima haqida ekanini
 * ekrandan bilib bo'lmasdi — balansim yo'qmi, grafikmi, ikkalasimi?
 *
 * ⚠️ Eng achinarlisi: matnlar ALLAQACHON uch tilda yozilgan va turgan
 * edi (`plans.loadFailed`, `usage.loadFailed`, `sessions.loadFailed`,
 * `payments.loadFailed`, `dashboard.loadFailed`) — beshtasi ham
 * kodning HECH BIR joyidan chaqirilmasdi. Ya'ni tarjimon ishlagan,
 * matn yozilgan, ekranga esa chiqmagan.
 *
 * <h2>Shakl — sarlavha va sabab ajratilgan (§23.2, 3-qoida)</h2>
 * «nima bo'ldi» sarlavhada («Paketlar ro'yxatini yuklab bo'lmadi»),
 * «nega va nima qilish kerak» pastida («Internetni tekshirib,
 * qayta urining»). Ikkalasini bitta qatorga qo'shib yuborish uzun,
 * o'qilmaydigan jumla berardi.
 */
export function LoadError({ titleKey, error }: LoadErrorProps) {
  const { t } = useTranslation()
  return (
    <Alert type="error" showIcon message={t(titleKey)} description={translateError(error, t)} />
  )
}
